import React from "react";
import { Link ,useLocation } from "react-router-dom";
import UseLangLstQuery from "Apis/LangTxtInqApi";

const MembJoinDoneUi = () => {
    const location = useLocation();
    const referrerParam = location.state?.referrer;
    const referrerUrl = (referrerParam && referrerParam !== "null") ? referrerParam : "/";
    // 전체 URL에서 경로만 추출
    // const referrer = (() => {
    //     try {
    //         const url = new URL(referrerUrl);
    //         return url.pathname + url.search + url.hash;
    //     } catch {
    //         return referrerUrl;
    //     }
    // })();
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    return(
        <div className="loginInputWrap">
            <div className="membJoinChkForm membFindTitl">
                <h1 className="membJoinDoneTitl">{langData&&langData.MEMB_JOIN_DONE_MAIN_TITL_00}</h1>
                {/* 가입완료 */}
                <p className="mt25">
                    {langData&&langData.MEMB_JOIN_DONE_MAIN_TITL_01}
                    <span className="membIdText">{location.state?.membId}</span>
                </p>
                {/* 환영합니다! 회원가입이 완료되었습니다. */}
                <p className="mt25">
                    {langData&&langData.MEMB_JOIN_DONE_MAIN_DESC_00}
                </p>
                <Link to={referrerUrl} className="loginBtn">{langData&&langData.COMM_MAIN_HOME_MAIN_BTN_00}</Link>
            </div>
        </div>
    )
}

export default MembJoinDoneUi;
